import React, { useState } from "react";

const EditProductForm = ({ product, onUpdateProduct, onCancel }) => {
  const [formData, setFormData] = useState({
    name: product.name || "",
    price: product.price || "",
    purchasePrice: product.purchasePrice || "",
    stock: product.stock !== undefined ? product.stock : "",
    barcode: product.barcode || "",
    antiGaspiDiscount: product.antiGaspiDiscount ?? "",
    antiGaspiMaxQty: product.antiGaspiMaxQty ?? "",
    antiGaspiStartsAt: product.antiGaspiStartsAt || "",
    antiGaspiExpiresAt: product.antiGaspiExpiresAt || "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!formData.name || !formData.price) return;
    
    const updatedProduct = {
      ...product,
      name: formData.name,
      price: parseFloat(formData.price),
      purchasePrice: parseFloat(formData.purchasePrice) || 0,
      stock: formData.stock === "" ? undefined : parseFloat(formData.stock),
      barcode: formData.barcode,
      antiGaspiDiscount:
        formData.antiGaspiDiscount === ""
          ? undefined
          : parseFloat(formData.antiGaspiDiscount),
      antiGaspiMaxQty:
        formData.antiGaspiMaxQty === ""
          ? undefined
          : Math.max(1, Math.round(Number(formData.antiGaspiMaxQty))),
      antiGaspiStartsAt: formData.antiGaspiStartsAt || undefined,
      antiGaspiExpiresAt: formData.antiGaspiExpiresAt || undefined,
    };
    
    // Once edited, the product is no longer incomplete
    delete updatedProduct.isIncomplete;

    onUpdateProduct(updatedProduct);
  };

  return (
    <div className="modal show d-block" style={{ backgroundColor: "rgba(0,0,0,0.5)", zIndex: 1055 }}>
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content shadow-lg border-0" style={{ backgroundColor: "#4b5563", color: "white", borderRadius: "12px" }}>
          <div className="modal-header border-bottom-0 pt-4 pb-0">
            <h5 className="modal-title fw-bold">MODIFIER PRODUIT</h5>
            <button type="button" className="btn-close btn-close-white" onClick={onCancel}></button>
          </div>
          <div className="modal-body">
            <form onSubmit={handleSubmit}>
              <div className="mb-3">
                <label className="form-label small text-info fw-bold">NOM</label>
                <input type="text" className="form-control bg-light" name="name" value={formData.name} onChange={handleChange} required />
              </div>
              <div className="mb-3">
                <label className="form-label small text-info fw-bold">CODE-BARRES</label>
                <input type="text" className="form-control bg-light" name="barcode" value={formData.barcode} onChange={handleChange} />
              </div>
              <div className="mb-3 row">
                <div className="col-4">
                  <label className="form-label small text-info fw-bold">STOCK</label>
                  <input type="number" step="any" className="form-control bg-light text-center fw-bold" name="stock" value={formData.stock} onChange={handleChange} />
                </div>
                <div className="col-4">
                  <label className="form-label small text-warning fw-bold">PRIX ACHAT</label>
                  <input type="number" step="0.01" className="form-control bg-light text-end fw-bold text-danger" name="purchasePrice" value={formData.purchasePrice} onChange={handleChange} />
                </div>
                <div className="col-4">
                  <label className="form-label small text-info fw-bold">PRIX VENTE</label>
                  <input type="number" step="0.01" className="form-control bg-light text-end fw-bold text-success" name="price" value={formData.price} onChange={handleChange} required />
                </div>
              </div>
              <div className="mb-3">
                <label className="form-label small text-success fw-bold">REMISE ANTI-GASPI (%)</label>
                <input type="number" min="0" max="90" className="form-control bg-light" name="antiGaspiDiscount" value={formData.antiGaspiDiscount} onChange={handleChange} placeholder="Ex: 30 (vide = aucun)" />
              </div>
              <div className="mb-3 row">
                <div className="col-4">
                  <label className="form-label small text-success fw-bold">QTÉ MAX REMISÉE</label>
                  <input type="number" min="1" className="form-control bg-light" name="antiGaspiMaxQty" value={formData.antiGaspiMaxQty} onChange={handleChange} placeholder="Ex: 5" />
                </div>
                <div className="col-4">
                  <label className="form-label small text-success fw-bold">DU</label>
                  <input type="date" className="form-control bg-light" name="antiGaspiStartsAt" value={formData.antiGaspiStartsAt} onChange={handleChange} />
                </div>
                <div className="col-4">
                  <label className="form-label small text-success fw-bold">AU</label>
                  <input type="date" className="form-control bg-light" name="antiGaspiExpiresAt" value={formData.antiGaspiExpiresAt} onChange={handleChange} />
                </div>
              </div>
              
              <div className="d-flex gap-2 mt-4">
                <button type="submit" className="btn btn-primary fw-bold flex-grow-1">ENREGISTRER</button>
                <button type="button" className="btn btn-secondary fw-bold px-4" onClick={onCancel}>ANNULER</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditProductForm;

